import { useEffect, useState } from "react";
import { fetchCategories } from "../lib/api";
import CategoryCard from "../components/CategoryCard";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Categories() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchCategories().then(setItems).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="categories-page">
      <Breadcrumbs items={[{ label: "Categories" }]} />
      <header className="mb-12 max-w-3xl">
        <p className="eyebrow mb-3">Categories</p>
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-neutral-900 tracking-tight leading-[1.05] mb-5">
          Software, organized the way you'd actually buy it.
        </h1>
        <p className="text-lg text-neutral-600 leading-relaxed">
          Browse software by the problem it solves. Each category hosts reviews,
          comparisons, and guides focused on that corner of the stack.
        </p>
      </header>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((c) => (
          <CategoryCard key={c.id} category={c} />
        ))}
      </div>
    </div>
  );
}
